// extracted by mini-css-extract-plugin
export default {"menu":"Certificate_menu__gxJ3R","nav":"Certificate_nav__w2QzS"};